import Route from '../../../services/route'
import Pagination, {Page} from '../../../components/pagination';
import messageDialog from "../../../components/message-dialog.vue";

export default {
  data(){
    return {
      routes: undefined,
      page: new Page().size(8),
      loading: undefined,
      search: '',
      filterActive: true,
      routeStatus: true,
      msgStrong: 'Nova forma de consulta',
      msg: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.',
      showAlert: true,
      showAlertWarning: true,
      warning: false,
      dataAtual:true
    }
  },
  mounted(){




  //   $('[data-toggle="tooltip"]').tooltip();
  //   this.loading = this.$store.dispatch('getRoutes').then(resp => {
  //     this.routes = this.allRoutes;
  //     this.page = this.page.itemCount(this.allRoutes ? this.allRoutes.length : 0);
  //     
  //   });

    if(this.allRoutes) {
      this.routes = this.allRoutes;
      this.page = this.page.itemCount(this.allRoutes ? this.allRoutes.length : 0);
    }
  },

  watch:{
    filterActive(){
      this.filter();
      this.search = '';
      this.page = this.page.page(1);
    }
  },

  computed: {
    allRoutes(){

      
      if(this.filterActive)
        return this.$store.getters.getRoutesActive;

      // ROTAS INATIVAS: FORAM COMENTADAS POR NÃO ESTARAM MAIS SENDO UTILIZADAS
      // return this.$store.state.route.inactives;
    },
    routesPaged() {
      if (this.routes && this.page) {
        for(let i=0; i<this.routes.length; i++) {
          this.$set(this.routes[i], 'open', false);
        }
        
        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown())
      }
      return undefined;
    }

  },
  methods: {

    searchRoutes() {
      $('[data-toggle="tooltip"]').tooltip();
        this.loading = this.$store.dispatch('getRoutes',  this.search ).then(resp => {

          if(this.allRoutes.length !== 0) {
            this.routes = this.allRoutes;
            this.page = this.page.itemCount(this.allRoutes ? this.allRoutes.length : 0);

            this.msgStrong = 'Nova forma de consulta';
            this.msg = 'Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.';
            this.warning = false;
          } else {
            this.msgStrong = 'Rota não encontrada!';
            this.msg = 'Faça uma nova busca ou cadastre uma nova rota.';
            this.warning = true;
          }
          this.showAlert = true;
          this.showAlertWarning = true;
        });
    },

    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },

    desativar(route){

      // r.routeId =
      // r.version = r.version;
      // r.totalDistance = this.result.totalDistance,
      // r.totalTime = this.result.totalTime,
      // r.totaltollFeeCost = this.result.totaltollFeeCost;
      // r.status = {status: 'INATIVA', statusId: 2};
      // r.points = this.locationPoints;
      // r.tollFees = [];
      // r.description = this.directionsDisplay.getDirections().routes[0].overview_polyline;
      //  {
      //   'routeId': id,
      //   'status.statusId': 2
      // }

      messageDialog.show({
        title: 'Excluir rota',
        message: 'Deseja excluir essa rota?',
        type: 'YES-NO'
      }).then(res => {
        if(res == 'YES'){
          this.routeStatus = false;
          this.createRoute('Rota excluída com sucesso', route);
        }
      });
    },

    createRoute(successMsg, route){

      let r = route;
      r.version += 1;
      r.status = {status: this.routeStatus ? 'ATIVA' : 'INATIVA', statusId: this.routeStatus ? 1 : 2};

      this.loading = Route.createRoute(r).then(res => {
        
        if(res.status.code == 0) {
          this.$store.commit('deleteRoute', r.routeId);
        } else {
          this.$router.push({name: 'routes'});
        }
      }).catch(res => {
        this.$router.push({name: 'routes'});
      });
    },

    getCity(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.city + ', ' + p.state;

      return "";
    },

    getAddress(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.address;

      return "";
    },

    imageMap(r){
      let origin = this.getAddress(r, 'origin');
      let dest = this.getAddress(r, 'destination');
      let url = "https://maps.googleapis.com/maps/api/staticmap?scale=1&size=260x150&maptype=roadmap&format=png&visual_refresh=true";
      url += `&markers=icon:https://movemais.com/static/pins/pin-origin-small.png%7Cshadow:true%7C${origin}`;
      url += `&markers=icon:https://movemais.com/static/pins/pin-destination-small.png%7Cshadow:true%7C${dest}`;

      _.filter(r.points, function(o){
        return o.type == 'waypoint';
      }).forEach(function(o){
        url += `&markers=icon:https://movemais.com/static/pins/pin-waypoint-small.png%7Cshadow:true%7C${o.address}`;
      });

      _.forEach(r.tollFeesPoint, function(o){
        url += `&markers=icon:https://movemais.com/static/pins/pin-toll-small.png%7Cshadow:true%7C${o.lat},${o.lng}`;
      });

      //let polyline = encodeURI('|x}cC|{`eHfDpQtJjJrj@}N~f@oKv[yGvDyDlDj@fBj@`BI|W~CnXtCjK~HrR{_@nyFk~IjzAocCpDeZtOyRpdCkoD`bDw`FjlBkvCnrBycDnfDylObOsGvAZle@rIv]s@hBxDtKKnJIpAcBsG{AwJF_EEgMHc^Nw@oRGWsZeWnC_TdWa_@zjAu}Af]iPne@fBx`CdWlXUxtCi~A|tC}_Bn{HohEt_KalDzlA_a@nUaWj{C_uIlVeRpTkEncAhC|]j@jTaPzIcQ~KeJdHsQzBmHkCaRfCmXfHkJvw@sf@ze@gKhn@_^rj@eLvMmJzG}Rlq@{c@rUFlReE~t@g[`f@p@r^qFpb@yYt_@yq@~Xoe@vx@y}@vd@_h@js@yw@lmAalAbz@gr@x`Aqo@`wAyg@`Kl@vWHrtBzYvbAbY~`AaDjnArIxdBzPjkAhD~zBwJvh@yBprC|_@rkIfrAlzB`^`{Alt@ra@r\\p]fg@rj@to@lLrHrw@fe@js@~`A~EnFbD|DjAvC|SjSnVaNlFcF~FOh[jJlGgRbGmQs@wFxEuKjBe@nK_GtGmQq@qIoFgC}`@wRoAuGjCwJnI_DlAkJr_@kwAte@evJtBs[vPes@dx@mlB`]}y@pYqtAvcAofFf]qdBpOeN~p@wOrTmWxc@m~@rhBeuDt}@miA|w@}{@rc@}w@xt@{~Azg@chAtgAcdCla@_~CrRc~@ns@}_ArHeYvAi{@hF_f@zp@kfAnMgdA|HuO|b@qNh\\kPxRqaAfQuo@z|@s|AzEcWuHu`CdKwb@|l@guAjF}ZqAal@jE{ObZyUvwA_WhqBaE|cAkr@|r@w\\p}@{CrSsC`RuS`|A}_Blx@}eAtb@{[vnAaf@jZkb@hfAazAzj@{l@h`AieAdlBofAtl@cQny@cl@lj@yd@|`@gt@`oAquArn@gQnUyUb[kq@lq@cx@d`AkcA~b@sc@b`@kTrnBif@dqA}[d`@gUjt@kaAhqBusCxo@mo@fh@gn@xMeNb]gL~OcKzg@kv@`x@it@`cAaId[mYlL}Gb`@mCdVyL~`@me@zQ_k@~EsD~K_DfbBmBxXgDhVwLpa@eb@tS_WlN}dArXuj@jJk_@dTqPha@eLdn@_\\pe@}j@bViGncDiK|eA{a@hbA}G|aAqXlgA}MvoA_V|j@{WnT{f@tOoIl[qC|c@kMrk@ud@z`Aiu@~B_cA{CyuAdKacAlRs`@`Vu{CxKw|B~EqTnRYroBtUba@nU|UhHdF_A`C}GiCyN^kDdBcGyDImCbDOA');
      url += `&path=enc:${r.description}&key=AIzaSyAzAwCX1zCJ9idWkNdxs39j36N4lAToIjE`;

      return url;
    },

    filter: _.debounce(function () {
      this.page = this.page.page(1);
      this.search = this.search.toUpperCase();

      if(!this.allRoutes)
        return;

      if (this.search == '') {
        this.routes = this.allRoutes;
        this.page = this.page.itemCount(this.routes.length);

        if(this.routes.length === 0) {
          this.showAlert = true
        } else {
          this.showAlert = false;
        }

        return;
      }
      this.routes = this.allRoutes.filter(value => {
        let a = value.name.toUpperCase().indexOf(this.search) >= 0 || value.flexfield1 && value.flexfield1.toUpperCase().indexOf(this.search) >= 0 || value.flexfield2 && value.flexfield2.toUpperCase().indexOf(this.search) >= 0;
        let b =_.filter(value.points, (o) => {
          
          
          return o.address && o.address.toUpperCase().indexOf(this.search) >= 0;
        }).length > 0;
        
        return a || b;
      });

      if(this.routes.length == 0) {
        this.msgStrong = 'Rota não encontrada!';
        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
        this.warning = true;
        this.showAlert = true;
      }else {
        this.showAlert = false;
      }

      this.page = this.page.itemCount(this.routes.length);

    }, 400),


  },
  components: {
    Pagination
  }
}
const r = [{"routeId": 1,"name": "Rota 1", "version": 1, "totalDistance":284,"totalTime":12508,"totaltollFeeCost":8860,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"address":"Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil","neighborhood":"Jardim das Flores","city":"Araraquara","state":"SP","country":"BR","lat":-21.789641,"lng":-48.205943700000034},{"type":"waypoint","sequence":2,"city":"São Carlos","state":"SP","country":"BR","address":"São Carlos, SP, Brasil","lat":-22.0087082,"lng":-47.89092629999999},{"type":"destination","sequence":3,"city":"São Paulo","state":"SP","country":"BR","address":"São Paulo, SP, Brasil","lat":-23.5505199,"lng":-46.63330940000003}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}}]}},
{"routeId": 2,"name": "Rota 2", "version": 2, "totalDistance":352,"totalTime":15834,"totaltollFeeCost":13900,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"city":"Araraquara","state":"SP","country":"BR","address":"Araraquara, SP, Brasil","lat":-21.7848272,"lng":-48.178648599999974},{"type":"destination","sequence":2,"city":"Santos","state":"SP","country":"BR","address":"Santos, SP, Brasil","lat":-23.9678823,"lng":-46.32888650000001}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}},{"direction":"S","address":"Piratininga - Diadema","concession":61800270,"pricePerAxle":5040,"point":{"lat":-23.820748,"lng":-46.582723}}]}},
{"routeId": 1,"name": "Rota 1", "version": 1, "totalDistance":284,"totalTime":12508,"totaltollFeeCost":8860,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"address":"Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil","neighborhood":"Jardim das Flores","city":"Araraquara","state":"SP","country":"BR","lat":-21.789641,"lng":-48.205943700000034},{"type":"waypoint","sequence":2,"city":"São Carlos","state":"SP","country":"BR","address":"São Carlos, SP, Brasil","lat":-22.0087082,"lng":-47.89092629999999},{"type":"destination","sequence":3,"city":"São Paulo","state":"SP","country":"BR","address":"São Paulo, SP, Brasil","lat":-23.5505199,"lng":-46.63330940000003}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}}]}},
{"routeId": 1,"name": "Rota 1", "version": 1, "totalDistance":284,"totalTime":12508,"totaltollFeeCost":8860,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"address":"Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil","neighborhood":"Jardim das Flores","city":"Araraquara","state":"SP","country":"BR","lat":-21.789641,"lng":-48.205943700000034},{"type":"waypoint","sequence":2,"city":"São Carlos","state":"SP","country":"BR","address":"São Carlos, SP, Brasil","lat":-22.0087082,"lng":-47.89092629999999},{"type":"destination","sequence":3,"city":"São Paulo","state":"SP","country":"BR","address":"São Paulo, SP, Brasil","lat":-23.5505199,"lng":-46.63330940000003}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}}]}},
{"routeId": 1,"name": "Rota 1", "version": 1, "totalDistance":284,"totalTime":12508,"totaltollFeeCost":8860,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"address":"Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil","neighborhood":"Jardim das Flores","city":"Araraquara","state":"SP","country":"BR","lat":-21.789641,"lng":-48.205943700000034},{"type":"waypoint","sequence":2,"city":"São Carlos","state":"SP","country":"BR","address":"São Carlos, SP, Brasil","lat":-22.0087082,"lng":-47.89092629999999},{"type":"destination","sequence":3,"city":"São Paulo","state":"SP","country":"BR","address":"São Paulo, SP, Brasil","lat":-23.5505199,"lng":-46.63330940000003}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}}]}},
{"routeId": 1,"name": "Rota 1", "version": 1, "totalDistance":284,"totalTime":12508,"totaltollFeeCost":8860,"routeStatus":{"status":"ATIVO"},"pointList":{"pointLocation":[{"type":"origin","sequence":1,"address":"Av. João Soares e Arruda - Jardim das Flores, Araraquara - SP, Brasil","neighborhood":"Jardim das Flores","city":"Araraquara","state":"SP","country":"BR","lat":-21.789641,"lng":-48.205943700000034},{"type":"waypoint","sequence":2,"city":"São Carlos","state":"SP","country":"BR","address":"São Carlos, SP, Brasil","lat":-22.0087082,"lng":-47.89092629999999},{"type":"destination","sequence":3,"city":"São Paulo","state":"SP","country":"BR","address":"São Paulo, SP, Brasil","lat":-23.5505199,"lng":-46.63330940000003}]},"tollFeeList":{"tollFee":[{"direction":"S","address":"Caieiras - Caieiras","concession":61800259,"pricePerAxle":1760,"point":{"lat":-23.347094,"lng":-46.813283}},{"direction":"S","address":"Itupeva Sul - Itupeva","concession":61800259,"pricePerAxle":1740,"point":{"lat":-23.058,"lng":-47.044724}},{"direction":"S","address":"Nova Odessa Sul - Nova Odessa","concession":61800259,"pricePerAxle":1540,"point":{"lat":-22.771006,"lng":-47.239073}},{"direction":"S","address":"Limeira A Sul - Limeira","concession":61800259,"pricePerAxle":1160,"point":{"lat":-22.510022,"lng":-47.397656}},{"direction":"S","address":"Itirapina - Itirapina","concession":61800263,"pricePerAxle":1000,"point":{"lat":-22.128961,"lng":-47.808042}},{"direction":"S","address":"Rio Claro - Rio Claro","concession":61800263,"pricePerAxle":1660,"point":{"lat":-22.374028,"lng":-47.620564}}]}},];



// WEBPACK FOOTER //
// ./src/pages/account/routing/routes.js